var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.482 19.9398H5.66536C5.7987 12.1564 7.33203 10.8731 12.1154 8.03976C12.6654 7.70643 12.8487 7.00643 12.5154 6.43976C12.1987 5.88976 11.482 5.70643 10.932 6.03976C5.2987 9.3731 3.33203 11.4064 3.33203 21.0898V30.0731C3.33203 32.9231 5.6487 35.2231 8.48203 35.2231H13.482C16.4154 35.2231 18.632 33.0064 18.632 30.0731V25.0731C18.632 22.1564 16.4154 19.9398 13.482 19.9398Z",
    fill: "#B1B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5182 19.9398H23.7016C23.8349 12.1564 25.3682 10.8731 30.1516 8.03976C30.7016 7.70643 30.8849 7.00643 30.5516 6.43976C30.2182 5.88976 29.5182 5.70643 28.9516 6.03976C23.3182 9.3731 21.3516 11.4064 21.3516 21.1064V30.0898C21.3516 32.9398 23.6682 35.2398 26.5016 35.2398H31.5016C34.4349 35.2398 36.6516 33.0231 36.6516 30.0898V25.0898C36.6682 22.1564 34.4516 19.9398 31.5182 19.9398Z",
    fill: "#B1B5C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuo);
export default __webpack_public_path__ + "static/media/Quo.8bb27532bf0bf61874fd03d047429799.svg";
export { ForwardRef as ReactComponent };